import { useEffect, useRef } from 'react';

const PlaceMap = (props) => {
  const { className, lat, lng, zoom, width, height } = props;

  const mapRef = useRef(null);

  useEffect(() => {
    if (window.google && lat && lng) {
      const position = { lat, lng };
      const map = new window.google.maps.Map(mapRef.current, {
        zoom,
        center: position,
        disableDefaultUI: true,
        zoomControl: true,
      });
      new window.google.maps.Marker({ position, map });
    }
  }, [lat, lng, zoom, !!window.google]);

  return (
    <div className={className}>
      {lat && lng && (
        <div
          ref={mapRef}
          style={{
            width,
            height: window.google ? height : 'auto',
          }}
        />
      )}
    </div>
  );
};

PlaceMap.defaultProps = {
  zoom: 15,
  width: 'auto',
  height: 'auto',
};

export default PlaceMap;
